import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Admin.css";
import axios from "axios";

const Admin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [totalStakeholder, setTotalStakeholder] = useState(0);
  const [totalPermintaan, setTotalPermintaan] = useState(0);
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    const fetchData = async () => {
      try {
        // Ambil data stakeholder
        const resStakeholder = await axios.get(
          "https://c-greenproject.org:7500/users"
        );
        setTotalStakeholder(resStakeholder.data.users.length);

        // Ambil data permintaan
        const resPermintaan = await axios.get(
          "https://c-greenproject.org:7500/riwayat",
          {},
          { withCredentials: true }
        );
        setTotalPermintaan(resPermintaan.data.requests.length);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleLogout = async () => {
    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );

      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Gagal logout. Silakan coba lagi.");
    }
  };
  return (
    <div className="d-flex flex-column">
      {/* Header */}
      <div className="header">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span>{userInfo.full_name} |</span>
          <button
            className="btn btn-outline-success btn-sm"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex">
        {/* Sidebar */}
        <div className="sidebar p-3">
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" /> {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/admin")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/admin" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/admin" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/admins")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/admins" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/admins" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/sell_8087698.png" alt="Stakeholder" />{" "}
              Stakeholder
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <h1>Beranda</h1>
          <div className="divider"></div>

          {/* Dashboard Cards */}
          <div className="row g-4 dashboard-cards">
            <div className="col-md-6">
              <div
                className="dashboard-card danger"
                onClick={() => navigate("/admins")}
              >
                <div className="card-icon">
                  <img src="/static/sell_8087698.png" alt="Stakeholder" />
                </div>
                <div className="card-content">
                  <h2>{totalStakeholder}</h2>
                  <p>Total Stakeholder</p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="dashboard-card success">
                <div className="card-icon">
                  <img src="/static/deliver.png" alt="Permintaan" />
                </div>
                <div className="card-content">
                  <h2>{totalPermintaan}</h2>
                  <p>Total Permintaan</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;
